import React, { useEffect, useState, useCallback, memo } from 'react';
import styles from './Toolbar.scss';
import { Box } from '@material-ui/core';

import { Button, BUTTON } from 'components/common/Button/Button';

import Styles from './Toolbar.scss';
import FilterPopover from './FilterPopover';
import SortPopover from './SortPopover';
import ActionsPopover from './ActionsPopover';
import CustomizePopover from './CustomizePopover';
import { uniq, map, forEach, debounce, forOwn } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes, faSort, faFilter, faCaretDown, faPlus, faSliders, faGripVertical, faXmark } from '@fortawesome/free-solid-svg-icons';

const Toolbar = memo(({ columns, data, onChangeFilter, filterRecord, setFilterRecord, dataCy, showFilterPills, dashboardCreateButton = false }) => {

    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const [sortAnchorEl, setSortAnchorEl] = useState(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(null);
    const [customizeAnchorEl, setCustomizeAnchorEl] = useState(null);

    const [searchInput, setSearchInput] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const [searchPlaceholder, setSearchPlaceholder] = useState('');
    const [showFilter, setShowFilter] = useState([]);
    const [showSort, setShowSort] = useState(false);
    const [showActions, setShowActions] = useState(false);
    const [showCustomize, setShowCustomize] = useState(false);

    const [sortLabel, setSortLabel] = useState('');
    const [createButton, setCreateButton] = useState({});

    const [isCreateAllowed, setIsCreateAllowed] = useState(false);

    const openFilter = Boolean(filterAnchorEl);
    const openSort = Boolean(sortAnchorEl);
    const openActions = Boolean(actionAnchorEl);
    const openCustomize = Boolean(customizeAnchorEl);

    const filterId = openFilter ? 'filter-popover' : undefined;
    const sortId = openSort ? 'sort-popover' : undefined;
    const actionsId = openActions ? 'actions-popover' : undefined;
    const customizeId = openCustomize ? 'customize-popover' : undefined;

    const atInitialState = false;
    const [showCreateButton, setShowCreateButton] = useState(false);

    const [filterPillsList, setFilterPillList] = useState([]);

    useEffect(() => {
        if (filterRecord.initial)
            generateToolbarObject();
        else if (showFilterPills)
            getFilterPills();
    }, [columns, data, filterRecord]);

    useEffect(() => {
        onChangeSearch(false);
    }, [onChangeSearch, searchInput]);

    const generateToolbarObject = async () => {
        try {
            if (dashboardCreateButton ? data.length : true) {
                const createButton = columns.filter(s => s.createButton);
                if (createButton.length !== 0) {
                    setIsCreateAllowed(createButton[0].isCreateAllowed);
                    setCreateButton({
                        label: createButton[0].label,
                        icon: createButton[0].icon,
                        execute: createButton[0].execute,
                    });
                    setShowCreateButton(true);
                }

            }
            if (data.length) {

                const searchData = columns.filter(s => s.toolbarSearch);
                const filterData = columns.filter(s => s.toolbarFilter);
                const sortData = columns.filter(s => s.toolbarSort);
                const actionData = columns.filter(s => s.actions);
                const customizeData = columns.filter(s => s.customize);

                if (searchData.length) {
                    setShowSearchInput(true);
                    setSearchPlaceholder(columns.filter(s => s.toolbarSearch)[0].searchPlaceholder || '');
                }

                let sortRecord = {};
                let filterRecord = {};
                if (filterData) {
                    let filterRecordData = filterData.map(s => {
                        let key = s.field;
                        if (s.toolbarFilterData) {
                            return {
                                label: s.title,
                                key,
                                type: s.toolbarFilter,
                                list: s.toolbarFilterData
                            };
                        }
                        let listRecord = uniq(map(data, key));
                        if (listRecord.length)
                            return {
                                label: s.title,
                                key,
                                type: s.toolbarFilter,
                                list: listRecord.map(s => ({ label: s, key: s + key }))
                            };
                        return null;
                    });
                    filterRecordData = filterRecordData.filter(s => s);
                    setShowFilter(filterRecordData);

                    filterRecordData.forEach(v => {
                        filterRecord[v.key] = [];
                    });
                }

                if (sortData) {
                    const sortRecordData = [];

                    forEach(sortData, (s) => {
                        let data = [];

                        if (s.singleSort) {
                            let label = s.field === 'accessStart' ? 'Access Start (Upcoming)' : 'Access End (Completed)';
                            let sortRecordValue = {
                                key: s.field,
                                label,
                                value: s.toolbarSort,
                                isDefault: s.toolbarSort == 'ASC' && s.toolbarDefaultSort,
                            };
                            data.push(sortRecordValue);
                        } else {
                            let sortRecordValueZA = {
                                key: s.field,
                                label: s.toolbarSortByPostFix ? s.title + s.toolbarSortByPostFix[0] : s.title + ' (Z-A)',
                                value: 'DESC',
                                isDefault: s.toolbarSort == 'DESC' && s.toolbarDefaultSort
                            };
                            let sortRecordValueAZ = {
                                key: s.field,
                                label: s.toolbarSortByPostFix ? s.title + s.toolbarSortByPostFix[1] : s.title + ' (A-Z)',
                                value: 'ASC',
                                isDefault: s.toolbarSort == 'ASC' && s.toolbarDefaultSort
                            };
                            data.push(sortRecordValueAZ);
                            data.push(sortRecordValueZA);
                        }

                        sortRecordData.push(...data);
                    });
                    setShowSort(sortRecordData);

                    let sort = sortRecordData.find((s) => s.isDefault);
                    if (sort) {
                        sortRecord.key = sort.key;
                        sortRecord.value = sort.value;
                    }
                    setSortLabel(sort.label);
                }
                if (actionData.length !== 0) {
                    const actionsList = [];
                    actionData[0].actionItems.map(action => {
                        const actionKey = action.key;
                        const actionLabel = action.label;
                        const actionIcon = action.icon;
                        const actionFunction = action.execute;

                        const actionItem = {
                            key: actionKey,
                            label: actionLabel,
                            icon: actionIcon,
                            function: actionFunction
                        };
                        actionsList.push(actionItem);
                    });
                    setShowActions(actionsList);
                }
                const customizeList = [];
                if (customizeData.length !== 0) {
                    customizeData[0].customizeItems.map(item => {
                        const customizeKey = item.key;
                        const customizeLabel = item.label;
                        const checked = item.checked;

                        const customizeItem = {
                            key: customizeKey,
                            label: customizeLabel,
                            checked: checked
                        };
                        customizeList.push(customizeItem);
                    });
                    setShowCustomize(customizeList);
                }
                setFilterRecord({ search: '', filter: filterRecord, sort: sortRecord, initial: false, customizedColumns: customizeList });
            }
        }
        catch (e) {
            return;
        }
    };

    const onChangeSearch = useCallback((isClear) => {
        isClear && setSearchInput('');
        let filterData = { ...filterRecord };
        filterData.search = !isClear ? searchInput : '';
        debouncedSearch(filterData);
    }, [debouncedSearch, filterRecord, searchInput]);

    const handleFilterClick = (event) => {
        if (event.currentTarget) {
            setFilterAnchorEl(event.currentTarget);
        }
    };

    const handleSortClick = (event) => {
        if (event.currentTarget) {
            setSortAnchorEl(event.currentTarget);
        }
    };
    const handleCustomizeClick = (event) => {
        if (event.currentTarget) {
            setCustomizeAnchorEl(event.currentTarget);
        }
    };

    const handleActionClick = (event) => {
        if (event.currentTarget) {
            setActionAnchorEl(event.currentTarget);
        }
    };

    const handleFilterClose = () => {
        setFilterAnchorEl(null);
    };
    const handleSortClose = () => {
        setSortAnchorEl(null);
    };
    const handleActionClose = () => {
        setActionAnchorEl(null);
    };
    const handleCustomizeClose = () => {
        setCustomizeAnchorEl(null);
    };
    const debouncedSearch = useCallback(debounce((value) => {
        onChangeFilter(value);
    }, 300), [onChangeFilter]);

    const getFilterPills = () => {
        let selectedFilters = [];
        forOwn(filterRecord.filter, (filterValue, filterKey) => {
            if (filterValue.length) {
                let filterKeyData = showFilter.find(f => f.key == filterKey);
                filterValue.forEach((value) => {
                    let filterString = '';
                    let lableValue = filterKeyData.list.find(f => f.key == value);
                    filterString = <span className={styles.filterText}>{filterKeyData.label} <span className={styles.normal}>is </span>{lableValue ? lableValue.label : filterValue[0]}</span>;
                    selectedFilters.push({ label: filterString, filterKeyData, value });
                });
            }
        });
        setFilterPillList(selectedFilters);
    };

    const onRemovePills = (filterData, filterValue) => {
        let allFilters = { ...filterRecord };
        let filterArray = allFilters.filter[filterData.key];
        let index = filterArray.indexOf(filterValue);
        
        if (index !== -1) {
            filterArray.splice(index, 1);
            allFilters.filter[filterData.key] = filterArray;
            onChangeFilter(allFilters);
        }
    };
    

    const onRemoveAllPills = () => {
        let allFilters = { ...filterRecord };
        let filterskeys = Object.keys(allFilters.filter);
        filterskeys.forEach((f) => {
            allFilters.filter[f] = [];
        });
        onChangeFilter(allFilters);
    };

    return (
        <Box className={Styles.Toolbar__toolbarSection}>
            <Box className={Styles.Toolbar__toolbarContainer}>
                <div className={styles.Toolbar__toolbarLeft}>
                    {showSearchInput ?
                        <span className={Styles.Toolbar__searchBoxContainer} data-cy={`${dataCy}-search`}>
                            <FontAwesomeIcon icon={faSearch} className={styles.Toolbar__searchIcon} />
                            <input className={styles.Toolbar__inputText}
                                type="text"
                                placeholder={`Search ${searchPlaceholder}`}
                                onChange={(e) => setSearchInput(e.target.value)}
                                value={searchInput}
                                data-cy="SearchBar-SearchTeam" />
                            {searchInput !== '' &&
                                <FontAwesomeIcon icon={faTimes} className={styles.Toolbar__clearIcon} onClick={() => onChangeSearch(true)} />}

                        </span> : null}
                    {showFilter.length ?
                        <div>
                            <Button
                                outline={BUTTON.OUTCOLOR.GREY}
                                bgcolor={BUTTON.BGCOLOR.CLEAR}
                                color={BUTTON.COLOR.BLACK}
                                aria-describedby={filterId}
                                type={BUTTON.SIZE.SECONDARY}
                                onClick={handleFilterClick}
                                prefixIcon={<FontAwesomeIcon icon={faFilter} className={styles.Toolbar__filterIcon} />}
                                text="Filter"
                                className={styles.Toolbar__filterButton}
                            />
                            <FilterPopover open={openFilter} anchorEl={filterAnchorEl} handleClose={handleFilterClose} id={filterId}
                                defaultFilterFields={showFilter} filterValue={filterRecord} onChangeFilter={onChangeFilter} dataCy={dataCy}
                                showCustomize={showCustomize} setShowCustomize={setShowCustomize}
                            />
                        </div>
                        : null
                    }
                    {showCustomize.length ?
                        <div>
                            <Button
                                outline={BUTTON.OUTCOLOR.GREY}
                                bgcolor={BUTTON.BGCOLOR.CLEAR}
                                color={BUTTON.COLOR.BLACK}
                                type={BUTTON.SIZE.SECONDARY}
                                onClick={handleCustomizeClick}
                                aria-describedby={customizeId}
                                prefixIcon={<FontAwesomeIcon icon={faSliders} className={styles.Toolbar__filterIcon} />}
                                text='Customize'
                                className={styles.Toolbar__filterButton}
                            />
                            <CustomizePopover icon={<FontAwesomeIcon icon={faGripVertical} className={styles.Toolbar__filterIcon} />} open={openCustomize} anchorEl={customizeAnchorEl} handleClose={handleCustomizeClose} id={customizeId} item={showCustomize} setShowCustomize={setShowCustomize} filterValue={filterRecord} onChangeFilter={onChangeFilter} dataCy={dataCy} />
                        </div>
                        : null
                    }
                    {showSort.length ?
                        <div>
                            <Button
                                outline={BUTTON.OUTCOLOR.GREY}
                                bgcolor={BUTTON.BGCOLOR.CLEAR}
                                color={BUTTON.COLOR.BLACK}
                                type={BUTTON.SIZE.SECONDARY}
                                onClick={handleSortClick}
                                aria-describedby={sortId}
                                prefixIcon={<FontAwesomeIcon icon={faSort} className={styles.Toolbar__filterIcon} />}
                                text={`Sort by: ${sortLabel || ''}`}
                                className={styles.Toolbar__filterButton}
                            />
                            <SortPopover open={openSort} anchorEl={sortAnchorEl} handleClose={handleSortClose} id={sortId} item={showSort} filterValue={filterRecord} setSortLabel={setSortLabel} onChangeFilter={onChangeFilter} dataCy={dataCy} />
                        </div>
                        : null
                    }
                </div>
                <div className={styles.Toolbar__toolbarRight}>
                    {showActions ?
                        <div>
                            <Button
                                outline={BUTTON.OUTCOLOR.GREY}
                                bgcolor={BUTTON.BGCOLOR.CLEAR}
                                color={BUTTON.COLOR.BLACK}
                                type={BUTTON.SIZE.SECONDARY}
                                onClick={handleActionClick}
                                aria-describedby={actionsId}
                                postfixIcon={<FontAwesomeIcon icon={faCaretDown} className={styles.Toolbar__actionIcon} />}
                                text="Actions" y
                                className={styles.Toolbar__filterButton}
                            />
                            <ActionsPopover open={openActions} anchorEl={actionAnchorEl} handleClose={handleActionClose} id={actionsId} item={showActions} dataCy={dataCy} />
                        </div>
                        : null
                    }
                    {(showCreateButton && isCreateAllowed) && <Button
                        dataCy={`${dataCy}-button}`}
                        bgcolor={atInitialState ? BUTTON.BGCOLOR.CLEAR : BUTTON.BGCOLOR.BLUE}
                        outline={atInitialState ? BUTTON.OUTCOLOR.LIGHTGREY : BUTTON.OUTCOLOR.NONE}
                        color={atInitialState ? BUTTON.COLOR.BLACK : BUTTON.COLOR.WHITE}
                        disabled={atInitialState}
                        onClick={() => createButton.execute()}
                        className={styles.Toolbar__createButton}
                    >
                        <span>
                            <FontAwesomeIcon icon={faPlus} className={styles.Toolbar__filterIcon} />
                            {createButton.label}
                        </span>
                    </Button>}
                </div>

            </Box>
            {showFilterPills && filterPillsList.length ?
                <Box>
                    <div className={styles.filterChipContainer}>
                        {filterPillsList.map((filterPill, index) => {
                            return (
                                <div className={styles.filterChip} key={index}>
                                    {filterPill.label}
                                    <span className={styles.removePill} onClick={() => onRemovePills(filterPill.filterKeyData, filterPill.value)}><FontAwesomeIcon icon={faXmark} style={{ width: '16px' }} /></span>
                                </div>
                            );
                        })}
                        <div className={styles.filterChipClearAll} onClick={onRemoveAllPills}>
                            Clear all
                        </div>
                    </div>
                </Box> :
                null
            }
        </Box>
    );
});
export default Toolbar;